export default "__VITE_ASSET__C618ceFy__"